function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3334 6L9.83341 0H2.50008C2.01385 0 1.54754 0.210714 1.20372 0.585786C0.859902 0.960859 0.666748 1.46957 0.666748 2V18C0.666748 18.5304 0.859902 19.0391 1.20372 19.4142C1.54754 19.7893 2.01385 20 2.50008 20H13.5001C13.9863 20 14.4526 19.7893 14.7964 19.4142C15.1403 19.0391 15.3334 18.5304 15.3334 18V6ZM5.25008 17H3.41675V8H5.25008V17ZM8.91675 17H7.08341V11H8.91675V17ZM12.5834 17H10.7501V14H12.5834V17ZM9.83341 7H8.91675V2L13.5001 7H9.83341Z",
  fill: "#454353"
});

function SvgReport2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "#454353",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport2);
export default __webpack_public_path__ + "static/media/report2.6fdbfa28efee1ac08814ad55baea58c2.svg";
export { ForwardRef as ReactComponent };